module.exports = __webpack_public_path__ + "img/certificate-IM-Pre.846b9082.png";